<template>
    <div class="modal-content fm-modal-about">
        <div class="modal-header">
            <h5 class="modal-title">{{ $t('filemanager.modal.about.title') }}</h5>
            <button type="button" class="close" aria-label="Close" v-on:click="hideModal">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <strong>{{ $t('filemanager.modal.about.name') }}</strong>
            <hr>
            <dl class="row">
                <dt class="col-3">{{ $t('filemanager.modal.about.version') }}:</dt>
                <dd class="col-9">{{ version }}</dd>

                <dt class="col-3">{{ $t('filemanager.modal.about.developer') }}:</dt>
                <dd class="col-9">Aleksandr Manekin (alexusmai@gmail.com)</dd>

                <dt class="col-3">GitHub:</dt>
                <dd class="col-9">
                    <a href="https://github.com/alexusmai/laravel-file-manager" target="_blank">
                        alexusmai/laravel-file-manager
                    </a>
                    <br>
                    <a href="https://github.com/alexusmai/vue-laravel-file-manager" target="_blank">
                        alexusmai/vue-laravel-file-manager
                    </a>
                </dd>
            </dl>
        </div>
    </div>
</template>

<script>
import modal from '../mixins/modal';

export default {
  name: 'About',
  mixins: [modal],
  computed: {
    /**
     * App version
     * @returns {*}
     */
    version() {
      return this.$store.state.settings.version;
    },
  },
};
</script>
